import type { FaireProductEntity } from "../../entity_types/product";

export const p_mmru3epfkp: FaireProductEntity = {
  token: "p_mmru3epfkp",
  type: "product",
  name: "Aquamarine double layer drop necklace",
  brandToken: "b_2j8dggjwrm",
  brandName: "Silver Sparrow Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/d1797b7827c1c2e05b209f1c579d06eaa221d7d7f11262af998a8f6c9359d216.png",
  galleryImageUrls: [],
  priceDollars: 14,
  description:
    "\nDescription\n\nThis double-layer necklace, crafted for versatility, can be worn together or separately for the perfect layered look. A beautiful combination of aquamarine, sunstone, and fluorite brings a touch of sweetness to your style.\n\nDetails\n\n * Semi-precious stones \n * Hand-knotted necklaces\n*Durable nylon cording\n\nDimensions: 16 and 18 inch, adjustable \n\nhypoallergenic hardware \n\nMade in Colorado ",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:01.340Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
